import { type EmbeddedModule, type LinkedModuleBuilds } from '@webapp2/shared/model'
import { computed } from 'vue'
import { registeredStateId, state, type BuildDownloadState, type BuildDownloadStatus } from '../state'
import { currentLinkedPlayerBuilds, ensureLinkedPlayerBuildsByPlayerBuildId } from './linked-player-builds-service'

export async function ensureLinkedPlayerBuildsForMultiplayerSessions() {
  const serverBuildIds = Object.values(state.multiplayerSessions).map(x => x.serverBuildId)
  await ensureLinkedPlayerBuildsByPlayerBuildId(serverBuildIds)
}

const isTutorial = (techniquePath: string) => techniquePath.toLowerCase().includes('tutorial')

export const currentEmbeddedModules = computed(() => {
  const link = currentLinkedPlayerBuilds.value
  const embeddedModules = link?.embeddedModules ?? []
  const visibleModules =
    link?.legacyWindowsEmbedded && state.platform !== 'windows'
      ? embeddedModules.filter(x => isTutorial(x.techniquePath))
      : embeddedModules
  return visibleModules.reduce<{ [techniquePath: string]: EmbeddedModule }>((acc, module) => {
    acc[module.techniquePath] = module
    return acc
  }, {})
})

export const downloadStatusByLinkedModuleBuildsId = computed(() => {
  const acc: { [linkedModuleBuildsId: string]: BuildDownloadStatus } = {}
  for (const link of Object.values(state.linkedModuleBuilds)) {
    const registered = state.registeredStates[registeredStateId(link.techniquePath)]
    const status =
      registered?.linkedModuleBuildsId === link.id
        ? { ...registered.downloadStatus, id: link.id }
        : {
            id: link.id,
            downloadedBytes: 0,
            totalBytes: 0,
            state: 'NotRegistered' as BuildDownloadState
          }
    acc[link.id] = status
  }
  return acc
})

export type TechniqueDetails = {
  link?: LinkedModuleBuilds
  courseLink?: LinkedModuleBuilds
  embeddedModule?: EmbeddedModule
  techniquePath: string
}

const embeddedModulesByTechniqueId = computed(() =>
  Object.values(currentEmbeddedModules.value).reduce<{ [techniqueId: string]: EmbeddedModule }>((acc, module) => {
    acc[module.techniqueId.toLowerCase()] = module
    return acc
  }, {})
)

export function embeddedModuleByTechniqueId(techniqueId: string): EmbeddedModule | undefined {
  return embeddedModulesByTechniqueId.value[techniqueId.toLowerCase()]
}

export const requiredTutorials = {
  singleplayer: 'Assets/OSSO-FoundationalTutorial/Scenes/FoundationalTutorial-TechniqueBuildData.asset',
  collab: 'Assets/OSSO-FoundationalTutorialCollab/Scenes/FoundationalTutorialCollab-TechniqueBuildData.asset'
}
